import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { TmaisFaqFormSchema } from '../schemas/form.schema'

interface UseCreateTmaisFaqProps {
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

const useCreateTmaisFaq = ({ onSuccess, onError }: UseCreateTmaisFaqProps = {}) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createTmaisFaq'],
    mutationFn: async (form: TmaisFaqFormSchema) => {
      const faq = {
        question: form.question.trim(),
        answer: form.answer.trim(),
      }

      return privateAxios.post('/tmais/faqs', { faq })
    },
    onSuccess,
    onError,
  })
}

export default useCreateTmaisFaq
